/**
 * Menu Item
 * Menu used on slide out menus in app
 */
import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React, { memo } from 'react';

import Icon from '@components/Icon/Icon';
import StackedIcon from '@components/Icon/StackedIcon';
import MenuArrow from '@components/MenuArrow/index';

import { ArrowContainer, IconWrapper, LineItem } from './MenuItem.style';

export interface MenuItemProps {
  text?: string;
  notifications?: number;
  onClick?: () => void;
  selected?: boolean;
  hideArrow?: boolean;
  icon?:
    | (Omit<FontAwesomeIconProps, 'color' | 'icon'> & {
        iconName: IconName;
        iconColor?: string;
      })[]
    | null;
}

function MenuItem({
  text = '',
  notifications = 0,
  onClick,
  selected = false,
  hideArrow = false,
  icon,
}: MenuItemProps) {
  return (
    <LineItem
      data-testid="menuitem-lineitem"
      onClick={() => onClick?.()}
      onKeyPress={() => onClick?.()}
      selected={selected}
    >
      <IconWrapper>
        {icon && icon.length === 1 ? (
          <Icon clickable name={icon[0].iconName} color="primary.main" />
        ) : icon && icon.length > 1 ? (
          <StackedIcon
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            icons={icon.map(({ iconColor, iconName, type, ...rest }) => ({
              ...rest,
              type: (type || 'fad') as IconPrefix,
              name: iconName,
              color: 'primary.main',
            }))}
          />
        ) : null}
      </IconWrapper>
      <div
        data-testid="menuitem-text"
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {text}
      </div>
      {!hideArrow && (
        <ArrowContainer>
          <MenuArrow notifications={notifications} selected={selected} />
        </ArrowContainer>
      )}
    </LineItem>
  );
}

export default memo(MenuItem);
